export default [{
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [{"color": "#444444"}]
}, {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [{"color": "#f2f2f2"}]
}, {
    "featureType": "landscape.natural.landcover",
    "elementType": "geometry.fill",
    "stylers": [{"visibility": "on"}, {"hue": "#ff0000"}]
}, {
    "featureType": "landscape.natural.terrain",
    "elementType": "geometry.fill",
    "stylers": [{"visibility": "on"}, {"hue": "#ff0000"}]
}, {"featureType": "poi", "elementType": "all", "stylers": [{"visibility": "off"}]}, {
    "featureType": "poi.park",
    "elementType": "all",
    "stylers": [{"lightness": "5"}, {"saturation": "30"}, {"gamma": "0.75"}, {"weight": "0.69"}]
}, {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [{"visibility": "on"}]
}, {
    "featureType": "poi.park",
    "elementType": "labels",
    "stylers": [{"visibility": "on"}, {"hue": "#ff0000"}]
}, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{"saturation": "-100"}, {"lightness": "7"}, {"visibility": "simplified"}, {"hue": "#ff0000"}]
}, {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [{"visibility": "simplified"}]
}, {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [{"visibility": "off"}]
}, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"}]}, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{"color": "#46bcec"}, {"visibility": "simplified"}, {"lightness": "13"}, {"saturation": "27"}, {"gamma": "1.93"}]
}]